import { FormationId } from '@wwf/sdk';

export const getLinkToFormation = (
    formationId: FormationId | undefined | null
) => {
    if (!formationId) return '';
    return `/formation?show=${formationId}`;
};
